export default __webpack_public_path__ + "static/media/swirly.549cf6ef.svg";